import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Typography from 'aquilla/core/atoms/Typography/Typography';
import { Spacings, breakpoints } from '@styles/index';

const PriceHikeContainer = styled.div`
  background-color: var(--color-i-pink-1);
  height: 56px;
  border-radius: ${({ borderRadius }) => borderRadius};
  padding: ${Spacings.SPACING_3B};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    text-align: left;
  }
`;

const PriceHikeContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PriceHikeIcon = styled.img`
  user-drag: none;
  user-select: none;
  width: 32px;
  height: 32px;
`;

const PriceHikeText = styled(Typography)`
  color: var(--color-i-red);
  margin-left: ${Spacings.SPACING_3B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 12px;
  }
`;

const PriceHike = ({ iconURL, message, borderRadius }) => {
  return (
    <PriceHikeContainer borderRadius={borderRadius}>
      <PriceHikeContent>
        <PriceHikeIcon src={iconURL} alt="-" />
        <PriceHikeText variant="h5">{message}</PriceHikeText>
      </PriceHikeContent>
    </PriceHikeContainer>
  );
};

PriceHike.propTypes = {
  iconURL: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  borderRadius: PropTypes.string
};

PriceHike.defaultProps = {
  borderRadius: Spacings.SPACING_2B
};

export default PriceHike;
